import { create } from "zustand";
import { toast } from "react-toastify";
import _ from "lodash";
import { transferCallToMpc } from "../api";

export const CALL_STATES = {
  AVAILABLE: "available",
  INCOMING: "incoming",
  RINGING: "ringing",
  CONNECTED: "connected",
  TRANSFERRING: "transferring",
  IN_MPC: "in_mpc",
  WRAP_UP: "wrap_up",
};

const RING_TIMEOUT_MS = 35000;

export const usePlivoStore = create((set, get) => ({
  callState: CALL_STATES.AVAILABLE,
  callDuration: 0,
  customerInfo: { name: "", phone: "" },
  isMuted: false,
  sdkReady: false,
  callUuid: null,
  mpcName: null,
  attemptId: null,
  engagementId: null,
  incomingCallerInfo: null,

  _timerInterval: null,
  _ringTimeout: null,

  setSdkReady: (ready) => set({ sdkReady: ready }),

  setCallState: (state) => {
    // Start ring timeout when entering RINGING, clear it otherwise
    const existingTimeout = get()._ringTimeout;
    if (existingTimeout) clearTimeout(existingTimeout);

    if (state === CALL_STATES.RINGING) {
      const timeout = setTimeout(() => {
        if (get().callState === CALL_STATES.RINGING) {
          console.log("PLIVO_STORE :: ring timeout — resetting call");
          get().resetCall();
        }
      }, RING_TIMEOUT_MS);
      set({ callState: state, _ringTimeout: timeout });
    } else {
      set({ callState: state, _ringTimeout: null });
    }
  },

  setCustomerInfo: (info) => set({ customerInfo: info }),
  setCallUuid: (uuid) => set({ callUuid: uuid }),
  setIncomingCall: (callerInfo) => set({
    callState: CALL_STATES.INCOMING,
    incomingCallerInfo: callerInfo,
  }),

  transferCall: async (doctorUserId, customerContext = {}) => {
    const { callUuid } = get();
    if (!callUuid) {
      toast.error("No active call to transfer");
      return;
    }
    try {
      set({ callState: CALL_STATES.TRANSFERRING });
      const response = await transferCallToMpc(callUuid, doctorUserId, customerContext);
      const mpcName = _.get(response, ["data", "data", "mpcName"], null);
      // Don't set IN_MPC here — let onCallAnswered handle it after MPC re-add auto-answer
      set({ mpcName });
      toast.success("Transfer initiated");
    } catch (error) {
      const fallbackError = _.get(error, ["message"], "Transfer failed");
      const errorMessage = _.get(error, ["response", "data", "message"], fallbackError);
      toast.error(errorMessage);
      set({ callState: CALL_STATES.CONNECTED });
    }
  },

  startTimer: () => {
    const existing = get()._timerInterval;
    if (existing) clearInterval(existing);

    set({ callDuration: 0 });
    const interval = setInterval(() => {
      set((state) => ({ callDuration: state.callDuration + 1 }));
    }, 1000);
    set({ _timerInterval: interval });
  },

  stopTimer: () => {
    const interval = get()._timerInterval;
    if (interval) clearInterval(interval);
    set({ _timerInterval: null });
  },

  resetCall: () => {
    const interval = get()._timerInterval;
    if (interval) clearInterval(interval);
    const ringTimeout = get()._ringTimeout;
    if (ringTimeout) clearTimeout(ringTimeout);
    set({
      callState: CALL_STATES.AVAILABLE,
      callDuration: 0,
      customerInfo: { name: "", phone: "" },
      isMuted: false,
      callUuid: null,
      mpcName: null,
      attemptId: null,
      engagementId: null,
      incomingCallerInfo: null,
      _timerInterval: null,
      _ringTimeout: null,
    });
  },
}));
